import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./create-application-details-ec.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./create-application-details-ec.component.scss?ngResource";
import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from "@angular/core";
import { SharedConstants } from "../../../../../shared/constants/shared.constants";
import { ApplicationCreateService } from "../../../shared/application-create.service";
import { AflaModuleStrategyService } from "../../../../../shared/services/afla-module-strategy/afla-module-strategy.service";
import { AppControllerService } from "../../../../../app-controller.service";
import { CRUDOperation } from "../../../../../shared/models/crud-operation-enum.model";
import { CreateApplicationViewBaseComponent } from "../../../shared/create-application-view-base/create-application-view-base.component";
import { CreateApplicationDetailsEcConstants } from "./create-application-details-ec.constants";
import { take, takeUntil } from "rxjs/operators";
import { SimulationUtils } from "src/app/shared/utils/simulation-utils";
let CreateApplicationDetailsEcComponent = class CreateApplicationDetailsEcComponent extends CreateApplicationViewBaseComponent {
    createApplicationService;
    aflaModuleStrategyService;
    appController;
    changeDetectorRefs;
    // Labels
    descriptionLabel = CreateApplicationDetailsEcConstants.DESCRIPTION_LABEL;
    applicationTypeLabel = CreateApplicationDetailsEcConstants.APPLICATION_TYPE_LABEL;
    whoIsApplyingLabel = CreateApplicationDetailsEcConstants.WHO_IS_APPLYING_LABEL;
    descriptionOfProposedWorkLabel = CreateApplicationDetailsEcConstants.DESCRIPTION_OF_PROPOSED_WORK_LABEL;
    descriptionOfProposedWorkNote = CreateApplicationDetailsEcConstants.DESCRIPTION_OF_PROPOSED_WORK_NOTE;
    phaseLabel = CreateApplicationDetailsEcConstants.PHASE_LABEL;
    conventionalPrepaidLabel = CreateApplicationDetailsEcConstants.CONVENTIONAL_PREPAID_LABEL;
    estimatedCapacityLabel = CreateApplicationDetailsEcConstants.ESTIMATED_CAPACITY_LABEL;
    // Form controls
    descriptionFormControlName = CreateApplicationDetailsEcConstants.DESCRIPTION_FORM_CONTROL_NAME;
    applicationTypeFormControlName = CreateApplicationDetailsEcConstants.APPLICATION_TYPE_FORM_CONTROL_NAME;
    applicantTypeFormControlName = CreateApplicationDetailsEcConstants.APPLICANT_TYPE_FORM_CONTROL_NAME;
    descriptionOfProposedWorkFormControlName = CreateApplicationDetailsEcConstants.DESCRIPTION_OF_PROPOSED_WORK_FORM_CONTROL_NAME;
    phaseFormControlName = CreateApplicationDetailsEcConstants.PHASE_FORM_CONTROL_NAME;
    paymentTypeControlName = CreateApplicationDetailsEcConstants.PAYMENT_TYPE_CONTROL_NAME;
    estimatedCapacityControlName = CreateApplicationDetailsEcConstants.ESTIMATED_CAPACITY_FORM_CONTROL_NAME;
    // constants
    validationMessages = CreateApplicationDetailsEcConstants.VALIDATION_MESSAGES;
    dropdownPlaceholderMessage = SharedConstants.PLACEHOLDER_TEXT;
    removeLabel = SharedConstants.REMOVE_LABEL;
    // variables
    detailsForm;
    applicationTypes = [];
    applicantTypes = [];
    phases = [];
    conventionalPrepaidOptions = [];
    constructor(createApplicationService, aflaModuleStrategyService, appController, changeDetectorRefs) {
        super(createApplicationService, aflaModuleStrategyService);
        this.createApplicationService = createApplicationService;
        this.aflaModuleStrategyService = aflaModuleStrategyService;
        this.appController = appController;
        this.changeDetectorRefs = changeDetectorRefs;
    }
    ngOnInit() {
        if (this.appController.moduleSimulateMode) {
            let defaults = SimulationUtils.simulate_Create_Application();
            this.applicationTypes = defaults.applicationType;
            this.applicantTypes = defaults.applicantType;
            this.phases = defaults.phases;
            this.conventionalPrepaidOptions = defaults.conventionalPrepaidOptions;
        }
        else {
            const lookupsLoaded = this.isLookupsLoaded();
            if (!lookupsLoaded) {
                this.getLookups();
            }
        }
        this.initForm();
        this.getMetadata();
    }
    ngOnDestroy() {
        this._destroy$.next();
        this._destroy$.complete();
    }
    loadMetadata(stepMeta) {
    }
    initForm() {
        const form = this.aflaModuleStrategyService.form.get(CreateApplicationDetailsEcConstants.DETAILS_FORM_GROUP_NAME);
        this.detailsForm = form;
    }
    getLookups() {
        const params = {
            $filter: `(moduleId eq ${this.appController.selectedModuleID}) and ((name eq '${CreateApplicationDetailsEcConstants.APPLICATION_TYPE_LOOKUP_NAME}' and deleted eq false) or (name eq '${CreateApplicationDetailsEcConstants.APPLICANT_TYPE_LOOKUP_NAME}' and deleted eq false) or (name eq '${CreateApplicationDetailsEcConstants.PHASE_LOOKUP_NAME}' and deleted eq false) or (name eq '${CreateApplicationDetailsEcConstants.CONVENTIONAL_PREPAID_LOOKUP_NAME}' and deleted eq false))`
        };
        this.createApplicationService
            .getLookupsObservable(params).pipe(takeUntil(this._destroy$), take(1)).subscribe({
            next: (response) => this.onGetLookupsCompleted(response),
            error: (error) => {
                this.appController.handleServerErrorMessage(CreateApplicationDetailsEcConstants.STEP_TITLE, error, CRUDOperation.Get);
            }
        });
    }
    onGetLookupsCompleted(response) {
        const applicationTypes = [];
        const applicantTypes = [];
        const phases = [];
        const conventionalPrepaid = [];
        if (response && response.value.length > 0) {
            response.value.forEach(item => {
                if (item.name === `${CreateApplicationDetailsEcConstants.APPLICATION_TYPE_LOOKUP_NAME}`) {
                    applicationTypes.push(JSON.parse(item.content));
                }
                if (item.name === `${CreateApplicationDetailsEcConstants.APPLICANT_TYPE_LOOKUP_NAME}`) {
                    applicantTypes.push(JSON.parse(item.content));
                }
                if (item.name === `${CreateApplicationDetailsEcConstants.PHASE_LOOKUP_NAME}`) {
                    phases.push(JSON.parse(item.content));
                }
                if (item.name === `${CreateApplicationDetailsEcConstants.CONVENTIONAL_PREPAID_LOOKUP_NAME}`) {
                    conventionalPrepaid.push(JSON.parse(item.content));
                }
            });
            applicationTypes.sort((a, b) => a.value.localeCompare(b.value));
            applicantTypes.sort((a, b) => a.value.localeCompare(b.value));
            phases.sort((a, b) => a.value.localeCompare(b.value));
            conventionalPrepaid.sort((a, b) => a.value.localeCompare(b.value));
            this.aflaModuleStrategyService.lookups.set(`${CreateApplicationDetailsEcConstants.APPLICATION_TYPE_LOOKUP_NAME}`, applicationTypes);
            this.aflaModuleStrategyService.lookups.set(`${CreateApplicationDetailsEcConstants.APPLICANT_TYPE_LOOKUP_NAME}`, applicantTypes);
            this.aflaModuleStrategyService.lookups.set(`${CreateApplicationDetailsEcConstants.PHASE_LOOKUP_NAME}`, phases);
            this.aflaModuleStrategyService.lookups.set(`${CreateApplicationDetailsEcConstants.CONVENTIONAL_PREPAID_LOOKUP_NAME}`, conventionalPrepaid);
            this.applicationTypes = applicationTypes;
            this.applicantTypes = applicantTypes;
            this.phases = phases;
            this.conventionalPrepaidOptions = conventionalPrepaid;
            this.changeDetectorRefs.detectChanges();
        }
    }
    isLookupsLoaded() {
        let lookupsAlreadyLoaded = false;
        const isApplicationTypeLookupLoaded = this.aflaModuleStrategyService.lookups.has(CreateApplicationDetailsEcConstants.APPLICATION_TYPE_LOOKUP_NAME);
        const isApplicantTypeLookupLoaded = this.aflaModuleStrategyService.lookups.has(CreateApplicationDetailsEcConstants.APPLICANT_TYPE_LOOKUP_NAME);
        const isPhase = this.aflaModuleStrategyService.lookups.has(CreateApplicationDetailsEcConstants.PHASE_LOOKUP_NAME);
        const isConventionalPrepaid = this.aflaModuleStrategyService.lookups.has(CreateApplicationDetailsEcConstants.CONVENTIONAL_PREPAID_LOOKUP_NAME);
        if (isApplicationTypeLookupLoaded && isApplicantTypeLookupLoaded && isPhase && isConventionalPrepaid) {
            this.applicationTypes = this.aflaModuleStrategyService.lookups.get(CreateApplicationDetailsEcConstants.APPLICATION_TYPE_LOOKUP_NAME);
            this.applicantTypes = this.aflaModuleStrategyService.lookups.get(CreateApplicationDetailsEcConstants.APPLICANT_TYPE_LOOKUP_NAME);
            this.phases = this.aflaModuleStrategyService.lookups.get(CreateApplicationDetailsEcConstants.PHASE_LOOKUP_NAME);
            this.conventionalPrepaidOptions = this.aflaModuleStrategyService.lookups.get(CreateApplicationDetailsEcConstants.CONVENTIONAL_PREPAID_LOOKUP_NAME);
            lookupsAlreadyLoaded = true;
        }
        return lookupsAlreadyLoaded;
    }
    static ctorParameters = () => [
        { type: ApplicationCreateService },
        { type: AflaModuleStrategyService },
        { type: AppControllerService },
        { type: ChangeDetectorRef }
    ];
};
CreateApplicationDetailsEcComponent = __decorate([
    Component({
        selector: "app-create-application-details-ec",
        template: __NG_CLI_RESOURCE__0,
        changeDetection: ChangeDetectionStrategy.OnPush,
        styles: [__NG_CLI_RESOURCE__1]
    })
], CreateApplicationDetailsEcComponent);
export { CreateApplicationDetailsEcComponent };
